<ng-template #team let-$team>
  <div class="team bg-{{$team.type}}-team text-{{$team.type}}-team">
    <div class="score w-100">
      @if (editable()) {
        <!-- DECREMENT SCORE -->
        <button class="score-button btn hover-highlight" (click)="$team.score = $team.score - 1">
          <i class="bi-dash-circle"></i>
        </button>
        <!-- CURRENT SCORE -->
        <div class="score-value heading-bold-text clickable hover-highlight" (click)="editScore($team)">
          {{$team.score}}
        </div>
        <!-- INCREMENT SCORE -->
        <button class="score-button btn hover-highlight" (click)="$team.score = $team.score + 1">
          <i class="bi-plus-circle"></i>
        </button>
      }

      @if (!editable()) {
        <div class="score-value heading-bold-text">
          {{$team.score}}
        </div>
      }
    </div>

    <div class="team-name heading-bold-text">
      {{$team.name}}
    </div>
  </div>
</ng-template>

<ng-container [ngTemplateOutlet]="team"
  [ngTemplateOutletContext]="{$implicit: match.teams.left}"
 />
<ng-container [ngTemplateOutlet]="team"
  [ngTemplateOutletContext]="{$implicit: match.teams.right}"
 />
@if (editable() && match.teams.optionalEnabled) {
  <ng-container [ngTemplateOutlet]="team"
    [ngTemplateOutletContext]="{$implicit: match.teams.optional}"
   />
}
